import { render } from "./ourClients.vue?vue&type=template&id=3a9c0ddf"
import script from "./ourClients.vue?vue&type=script&lang=js"
export * from "./ourClients.vue?vue&type=script&lang=js"

import "./ourClients.vue?vue&type=style&index=0&id=3a9c0ddf&lang=css"

import exportComponent from "/home/runner/work/intelli-landing-frontend/intelli-landing-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__